const StoreReducer = (state, action) => {
  switch (action.type) {
    case "RESET_FORM":
      // console.log('na reset');
      return {
        ...state,
        userContact: {
          company: "",
          concern: "",
          contactNumber: "",
          emailAddress: "",
          fullName: "",
          mallBranch: "",
          message: ""
        }
      };
    case "GET_USER":
      const { fetched_user, fetch_otp_generate } = action.payload;
      const { otpGenerate } = fetch_otp_generate;
      return {
        ...state,
        otpGenerate: otpGenerate.otp,
        user: fetched_user
      };
    // case "GET_OTP_GENERATE":
    //   const { fetched_otp_generate } = action.payload;
    //   return {
    //     ...state,
    //     otpGenerate: fetched_otp_generate
    //   };
    case "GET_OTP_VERIFY":
      const { fetched_otp_verify } = action.payload;
      return {
        ...state,
        otpVerify: fetched_otp_verify
      };
    case "GET_ERROR":
      const { fetched_error } = action.payload;
      return {
        ...state,
        error: fetched_error
      };
    default:
      return state;
  }
};
export default StoreReducer;
